export class ProjectionSettings {
  showClouds = false;
  showShapes = true;
}
